"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popover = void 0;
var popover = {
  colors: {
    default: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'white');
      },
      borderColor: function borderColor(get) {
        return get('colorScheme', 'dark25Alpha');
      }
    }
  },
  fontWeight: {
    default: '400'
  },
  margin: {
    topBottom: '0.5rem',
    leftRight: '0.5rem',
    bottomTop: '0.5rem',
    rightLeft: '0.5rem'
  },
  fontFamily: {
    default: ' -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  },
  borderRadius: function borderRadius(get) {
    return get('globals', 'borderRadius');
  },
  border: function border(get) {
    return get('globals', 'border');
  },
  fontSize: function fontSize(get) {
    return get('globals', 'fontSize');
  }
};
exports.popover = popover;